module.exports = __webpack_public_path__ + "img/outbrain.20800657.png";